import Checkbox from 'antd/lib/checkbox/Checkbox';
import React from 'react';

import { ICommonInputProps } from './types';

const CheckboxInput: React.FC<ICommonInputProps> = ({ disabled, name, onChange, value, inputClassName }) => {
  const handleChange = (e: any) => {
    onChange?.(e.target.checked, name);
  };
  return (
    <Checkbox
      className={`checkbox-input ${inputClassName}`}
      onChange={handleChange}
      checked={!!value}
      name={name}
      id={name}
      disabled={disabled}
    />
  );
};
export default React.memo(CheckboxInput);
